import React, { useState } from 'react';
import { ArrowLeft, Printer, Download } from 'lucide-react';
import type { CertificateActionsProps } from '../../../types/preEmployment.types';

const CertificateActions: React.FC<CertificateActionsProps> = ({
  onBack,
  onPrint,
  onDownloadPDF,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await onDownloadPDF();
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="bg-gray-100 p-4 flex justify-between items-center print:hidden">
      <button
        onClick={onBack}
        className="flex items-center gap-2 px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition duration-200"
        aria-label="Retour à la page précédente"
      >
        <ArrowLeft size={18} />
        Retour
      </button>

      <div className="flex gap-3">
        <button
          onClick={onPrint}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition duration-200"
          aria-label="Imprimer le certificat"
        >
          <Printer size={18} />
          Imprimer
        </button>
        <button
          onClick={handleDownload}
          disabled={isDownloading}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition duration-200 ${
            isDownloading
              ? 'bg-green-400 text-white cursor-not-allowed'
              : 'bg-green-600 hover:bg-green-700 text-white'
          }`}
          aria-label="Télécharger le certificat en PDF"
          aria-disabled={isDownloading}
        >
          {isDownloading ? (
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            <Download size={18} />
          )}
          {isDownloading ? 'Génération...' : 'Télécharger PDF'}
        </button>
      </div>
    </div>
  );
};

export default CertificateActions;